module.exports = __webpack_public_path__ + "static/media/icon_garantee_summary.7f082e38.svg";